import * as React from 'react';
import { ActionButton, fetchApi, notifyError, notifyResponse } from 'gossamer-front-end';
import { AdminInstitutionGroupEventRemoveRequest, InstitutionGroupEvent, InstitutionGroupEventView } from 'cb-model';

export interface RemoveEventFromGroupButtonProps {
  value: string; // institution group event id
  handleSuccess?: () => void;
}

export const RemoveEventFromGroupButton: React.FC<RemoveEventFromGroupButtonProps> = (props) => {
  return (
    <ActionButton
      label="Remove from Group"
      size="sm"
      variant="danger"
      waiting={false}
      execute={async (resetCache) => {
        try {
          const response = await fetchApi('POST', `/main/institution-group-event-remove`, {
            institutionGroupEventId: Number(props.value),
          } as AdminInstitutionGroupEventRemoveRequest);
          resetCache(InstitutionGroupEvent.id, props.value);
          resetCache(InstitutionGroupEventView.id, props.value);
          notifyResponse(response);
          if (props.handleSuccess) {
            props.handleSuccess();
          }
        } catch (e) {
          notifyError(e, 'An error occurred while removing the event from the group');
        }
      }}
    />
  );
};
